import { render } from "./TheLoginForm.vue?vue&type=template&id=acc71a3a&scoped=true"
import script from "./TheLoginForm.vue?vue&type=script&lang=js"
export * from "./TheLoginForm.vue?vue&type=script&lang=js"

import "./TheLoginForm.vue?vue&type=style&index=0&id=acc71a3a&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acc71a3a"]])

export default __exports__